// extracted by mini-css-extract-plugin
export default {"pag":"Pagination_pag__xjGN1","container":"Pagination_container__Xor0f"};